// operation

export default [
  {
    path: '/operation',
    name: 'operation',
    redirect: '/operation/list',
    component: () =>
    import(/* webpackChunkName: "operation" */ '@/components/operating-system/index'),
    children: [
      { path: 'list',
        component: () => import(/* webpackChunkName: "operation" */ '@/components/operating-system/list'),
        name: 'operationList'
      },
      { path: 'detail',
        component: () => import(/* webpackChunkName: "operation" */ '@/components/operating-system/detail'),
        name: 'operationDetail'
      },
      { path: 'edit',
        component: () => import(/* webpackChunkName: "operation" */ '@/components/operating-system/edit'),
        name: 'operationEdit'
      },
      { path: 'correctingPaper',
        component: () => import(/* webpackChunkName: "operation" */ '@/components/operating-system/correcting-paper/testList'),
        name: 'correctingPaper'
      },
      { path: 'paperList',
        component: () => import(/* webpackChunkName: "operation" */ '@/components/operating-system/correcting-paper/paperList'),
        name: 'paperList'
      },
      {
        path: 'paperDesc',
        component: () => import(/* webpackChunkName: "operation" */ '@/components/operating-system/correcting-paper/paperDesc'),
        name: 'paperDesc'
      }
    ]
  }
]

// export default [
//   {
//     path: '/operation',
//     name: 'operation',
//     component: () =>
//     import(/* webpackChunkName: "operation" */ '@/components/operating-system/index')
//   },
//   { path: '/operation/edit',
//     component: () => import(/* webpackChunkName: "operation" */ '@/components/operating-system/edit'),
//     name: 'operationEdit'
//   },
//   { path: '/operation/detail',
//     component: () => import(/* webpackChunkName: "operation" */ '@/components/operating-system/detail'),
//     name: 'operationDetail'
//   }
// ]



// WEBPACK FOOTER //
// ./src/router/router-child/operation.js